import RestService from './RestService';

async function addProduct(product) {
	try {
		const res = await RestService.performRestOpNext(`authorizer/product/create`, product);
		console.log(res);
		return { success: true };
	} catch (e) {
		if (e.response.data.message) {
			return { success: false, message: e.response.data.message };
		} else {
			return { success: false, message: e.message };
		}
	}
}

async function updateProduct(product) {
	try {
		await RestService.performRestOpNext(`authorizer/product/update`, product);
		return { success: true };
	} catch (e) {
		if (e.response.data.message) {
			return { success: false, message: e.response.data.message };
		} else {
			return { success: false, message: e.message };
		}
	}
}

async function getProduct(domain, slug) {
	try {
		const res = await RestService.performRestOpNext(`authorizer/product/get-raw`, { domain, slug });
		console.log(res);
		return res;
	} catch (e) {
		if (e.response.data.message) {
			return { success: false, message: e.response.data.message };
		} else {
			return { success: false, message: e.message };
		}
	}
}

export default {
	addProduct,
	updateProduct,
	getProduct
};
